var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24 24h-24v-24h24z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor ",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.62997912 17.16368c-2.67793496-3.822125-1.98991566-9.05716576 1.5846726-12.05754803s8.84964198-2.77053292 12.14970738.52939789 3.5301299 8.57497514.5298934 12.14968574c-3.0002365 3.5747107-8.2352492 4.2629435-12.05748338 1.5851644l-2.83727.63045z",
    transform: "matrix(-1 0 0 1 24.001038 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.823 11.823c.098-.098.256-.098.354 0s.098.256 0 .354-.256.098-.354 0c-.097-.098-.097-.256 0-.354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.823 11.823c.098-.098.256-.098.354 0s.098.256 0 .354-.256.098-.354 0c-.097-.098-.097-.256 0-.354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.823 11.823c.098-.098.256-.098.354 0s.098.256 0 .354-.256.098-.354 0c-.097-.098-.097-.256 0-.354"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.cbf638a3b234e8a7a777bd614d93fb21.svg";
export { ForwardRef as ReactComponent };